module.exports = __webpack_public_path__ + "img/alcoholera-esquema.76784833.png";